import routeName from '@/router/constant';

const typeName = 'pdf';

export const pdfHeader = [
    {
        path: 'pdf-terms',
        name: routeName.PDF_TERMS,
        component: () => import('@/views/pdf/login/Index.vue'),
        meta: {
            auth: false,
            metaTitle: '簡訊電子通知查詢',
            pageTitle: '簡訊電子通知查詢',
            subtitle: '本查詢功能僅提供當次簡訊所寄發之電子通知單',
        },
    },
    {
        path: `${typeName}-login`,
        name: routeName.PDF_LOGIN,
        component: () => import('@/views/pdf/login/Index.vue'),
        meta: {
            auth: false,
            metaTitle: '簡訊電子通知查詢',
            pageTitle: '簡訊電子通知查詢',
            subtitle: '本查詢功能僅提供當次簡訊所寄發之電子通知單',
        },
    },
];
